const displayNamesByLocale = new Map<string, Intl.DisplayNames | null>();

export function getRegionDisplayName({ code, locale }: { code: string; locale: string }): string {
	if (!displayNamesByLocale.has(locale)) {
		let displayNames: Intl.DisplayNames | null = null;
		if (typeof Intl !== "undefined" && typeof Intl.DisplayNames === "function") {
			try {
				displayNames = new Intl.DisplayNames([locale], { type: "region" });
			} catch {}
		}
		displayNamesByLocale.set(locale, displayNames);
	}
	return displayNamesByLocale.get(locale)?.of(code) ?? code;
}
